// 3rd party
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

// components
import { AppComponent } from 'app/app.component';

// services
import { AuthService } from 'app/shared/services/auth/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  @ViewChild('userLogin') userLogin: ElementRef;
  @ViewChild('userPassword') userPassword: ElementRef;

  domainHint: string = null;
  isLoading: boolean = false;
  passHint: string = null;
  userHint: string = null;

  constructor(
    private app: AppComponent,
    private authService: AuthService,
    private router: Router,
    public snackBar: MatSnackBar,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    let userLogin = localStorage.getItem('lastUser');
    this.userLogin.nativeElement.value = userLogin;
  }

  login() {
    this.validateUser();
    this.validatePass();
    if (this.passHint || this.userHint) {
      return;
    }
    this.isLoading = true;
    let login: string = this.userLogin.nativeElement.value;
    let password: string = this.userPassword.nativeElement.value;
    this.authService.login(login, password).then(cc => {
      this.isLoading = false;
      if (this.app.showApp) {
        this.router.navigate([`/${cc.Domain}/instruments`]);
      } else {
        this.translate.get('Translate.ErrorOcurred').subscribe(val => this.openSnackbar(val));
      }
    }, err => {
      let body = err._body;
      this.isLoading = false;

      if (body) {
        if (body.includes('Field "password" is incorrect.')) {
          this.translate.get('Translate.WrongPassword').subscribe(val => this.openSnackbar(val));
          return;
        }
        if (body.includes('Field "login" is incorrect.')) {
          this.translate.get('Translate.InvalidUser').subscribe(val => this.openSnackbar(val));
          return;
        }

        if (body.includes('Could not login')) {
          this.translate.get('Translate.InvalidDomain').subscribe(val => this.openSnackbar(val));
          return;
        }
      } else {
        this.translate.get('Translate.ErrorOcurred').subscribe(val => this.openSnackbar(val));
      }
    });
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, 'Ok', {
      duration: 3000
    });
  }

  validatePass() {
    if (!this.userPassword.nativeElement.value) {
      this.translate.get('Translate.FieldCannotBeNull').subscribe((val) => this.passHint = val);
    } else {
      this.passHint = null;
    }
  }

  validateUser() {
    if (!this.userLogin.nativeElement.value) {
      this.translate.get('Translate.FieldCannotBeNull').subscribe((val) => this.userHint = val);
      return;
    }

    let login = this.userLogin.nativeElement.value.split('@');
    if (!login || login.length < 2 || login[login.length - 1].length < 2) {
      this.translate.get('Translate.EmptyDomain').subscribe((val) => this.userHint = val);
      return;
    }
    this.userHint = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/login/login-default/login.component.ts